module.exports = __webpack_public_path__ + "img/shopee_9thb_0006.ef45a6f5.png";